module.exports = "<textarea\n    id=\"{{elementId}}\"\n></textarea>\n"